import React, { Component } from 'react'
import imageCompression from 'browser-image-compression';

export default {
    resizeImageBeforeUpload: async function (photo) {
        let compressedFile = {};
        const options = {
            maxSizeMB: 1,
            maxWidthOrHeight: 1920,
            useWebWorker: true
        }

        try {

            compressedFile = await imageCompression(photo, options);
            //console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
            //console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB


        } catch (error) {
            throw 'Error in uploading files.'
        }
        return compressedFile;
    }
}